import React, { Component } from 'react';

import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import ImagePanel from '@components/ImagePanel/ImagePanel';
import CloudPanel from '@components/CloudPanel/CloudPanel';
import CrewList from './CrewList/CrewList';
import Helmet from 'react-helmet';
import { leadershipData } from './leadership-data';
import ImportImages from '@src/importImages';

const Image = ImportImages('/leadership/leadership.jpg');

class Leadership extends Component {
  state = {
    crewData: leadershipData,
    extended: [],
    modal: false,
    modalContentId: 0
  };

  toggleExtendHandler = id => {
    const currentExtended = [...this.state.extended];
    if (currentExtended.indexOf(id) !== -1) {
      const index = currentExtended.indexOf(id);
      currentExtended.splice(index, 1);
    } else {
      currentExtended.push(id);
    }
    const currentModal = this.state.modal;

    this.setState({
      extended: currentExtended,
      modal: !currentModal,
      modalContentId: id
    });
  };

  render = () => {
    const containerProps = {
      pageHeight: this.props.pageHeight
    };
    containerProps.autoScroll = {
      active: 1,
      delay: 1000
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>Leadership | JetSuite</title>
          <meta name="description" content={'JetSuite Leadership'} />
        </Helmet>
        <ScrollContainer {...containerProps}>
          <ImagePanel
            id={'leadership-imagepanel'}
            screenHeight={this.props.pageHeight}
            image={Image}
            alt={'Leadership'}
          />
          <CloudPanel
            id={'leadership-cloudpanel'}
            hideJSILogo={true}
            screenHeight={this.props.pageHeight}
          >
            <CrewList
              {...this.state}
              pageWidth={this.props.pageWidth}
              toggleExtended={id => this.toggleExtendHandler(id)}
              extended={this.state.extended}
              heightSm={this.props.heightSm}
            />
          </CloudPanel>
        </ScrollContainer>
      </React.Fragment>
    );
  };
}

export default Leadership;



// WEBPACK FOOTER //
// ./src/components/Leadership/Leadership.jsx